import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "kl-number-schema-list",
  templateUrl: "./number-schema-list.component.html",
  styleUrls: ["./number-schema-list.component.scss"],
})
export class NumberSchemaListComponent implements OnInit {
  @Input() tabId: string;
  @Input() modalId: string;
  filterSelectItems = [
    {
      name: "code",
      description: "code",
    },
  ];

  constructor() {}

  ngOnInit() {}
}
